import platform from "@utils/platform";
import { getUrlArg } from "@utils/urlUtil";
import { Toast } from "@utils/page";
import VConsole from "vconsole";
import { queryUrl } from "@/api/common";
import { encrypt } from "@/utils/index";

if (process.env.curEnv != "prod") {
    new VConsole();
}

let key = getUrlArg("k") || undefined;
let channel = getUrlArg("t") || undefined;
let params = {
    key,
    channel,
    pushFlag: true
};

if (process.env.curEnv === "dev") {
    // tt
    let userInfo = {
        code: "oOCyauBp47TnhkVVkd1_AM7OSe60",
        avatar: "https://file.40017.cn/huochepiao/activity/20200521supplies/img/defaultImg-fs8.png",
        nick: "同程用户",
        unionid: "ohmdTtzJ57uMimh_0PtDCn5LVx04"
    };
    params.scanUnionId = userInfo.unionid;
    params.timestamp = new Date().getTime();
    params.nonce = Math.random().toString(36).substr(2);
    let sign = encrypt(params);
    params.sign = sign;
    queryUrl(params)
        .then(res => {
            if (res.code === "0") {
                let url = res.data.url;
                if (url.includes("pages/index/index")) {
                    location.href = `weixin://dl/business/?appid=${res.data.appId}&path=pages/index/index`;
                    return;
                }
                if (url.includes("pages/shareIn/register/index")) {
                    let p = url.split("?")[1];
                    location.href = `weixin://dl/business/?appid=${res.data.appId}&path=pages/shareIn/register/index&query=${encodeURIComponent(p)}`;
                    return;
                }
                if (!url.startsWith("http://") && !url.startsWith("https://")) {
                    url = "http://" + url;
                }
                window.location.href = url;
            } else {
                Toast(res.msg);
            }
        })
        .catch(err => {
            console.log("🚀 ~ queryUrl ~ err:", err);
        });
} else {
    platform
        .getAuth({
            searchArgs: ["k", "t"],
            isGetUserInfo: false,
            isHash: true
        })
        .then(data => {
            let userInfo = data.userInfo;
            params.scanUnionId = userInfo.unionid;
            params.timestamp = new Date().getTime();
            params.nonce = Math.random().toString(36).substr(2);
            let sign = encrypt(params);
            params.sign = sign;
            queryUrl(params)
                .then(res => {
                    if (res.code === "0") {
                        let url = res.data.url;
                        if (url.includes("pages/index/index")) {
                            location.href = `weixin://dl/business/?appid=${res.data.appId}&path=pages/index/index`;
                            return;
                        }
                        if (url.includes("pages/shareIn/register/index")) {
                            let p = url.split("?")[1];
                            location.href = `weixin://dl/business/?appid=${res.data.appId}&path=pages/shareIn/register/index&query=${encodeURIComponent(p)}`;
                            return;
                        }
                        if (!url.startsWith("http://") && !url.startsWith("https://")) {
                            url = "http://" + url;
                        }
                        window.location.href = url;
                    } else {
                        Toast(res.msg);
                    }
                })
                .catch(err => {
                    console.log("🚀 ~ queryUrl ~ err:", err);
                });
        });
}
